module.exports = __webpack_public_path__ + "img/20220810090711.87894ef4.jpg";